// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDFXxqL047V_1JBPhIMVb4Zty3RmifVBj8",
  authDomain: "gemiqai.firebaseapp.com",
  projectId: "gemiqai",
  storageBucket: "gemiqai.firebasestorage.app",
  messagingSenderId: "224619368481",
  appId: "1:224619368481:web:1B7b536a381f4ccf48a5d8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;

